import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { GetTheApp } from 'components/GetTheApp';
import useGenerateAppDownloadUrl from 'hooks/useGenerateAppDownloadUrl';
import { getDevicePlatform } from 'modules/meta/selectors';
import { getLanguageCode } from 'utils/localization/language';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { NoStyleLink } from '@daedalus/atlas/helpers/NoStyleLink';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { getClosestDataIdToEventTarget } from '@daedalus/core/src/_web/utils/browser';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import { Placement } from '@daedalus/core/src/deepLinking/types';
import { isReactNativeWebView } from '@daedalus/core/src/native';
import { AppleAppStoreBadge, GooglePlayBadge } from '@daedalus/shared/src/search/footer/AppButtonsWidget/AppButtonsWidget';
const _exp = /*#__PURE__*/() => NoStyleLink;
const GetTheAppButton = /*#__PURE__*/styled(_exp())({
  name: "GetTheAppButton",
  class: "g1a5s7md",
  propsAsIs: true
});
export const GetTheAppFooterWidget = () => {
  const lang = getLanguageCode();
  const {
    isDesktop
  } = useDeviceLayout();
  const dispatch = useDispatch();
  const isAndroid = useSelector(getDevicePlatform) === 'android';
  const {
    brandIsVio
  } = useBrand();
  const isWebView = isReactNativeWebView();
  const {
    generateAppStoreDeepLink,
    generatePlayStoreDeepLink
  } = useGenerateAppDownloadUrl();
  if (!brandIsVio || isWebView) return null;
  const handleDownloadAppLink = (event: React.MouseEvent) => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.AppInstallLink,
      action: Action.Clicked,
      payload: {
        selectedElement: getClosestDataIdToEventTarget(event)
      }
    }));
    const downloadAppURL = isAndroid ? generatePlayStoreDeepLink(Placement.Footer) : generateAppStoreDeepLink(Placement.Footer);
    window.open(downloadAppURL, '_blank');
  };
  if (isDesktop) return <GetTheApp dataId="desktop_footer" placement={Placement.Footer} />;
  return <GetTheAppButton data-id="mobile_footer" onClick={handleDownloadAppLink}>
      {isAndroid ? <GooglePlayBadge lang={lang} /> : <AppleAppStoreBadge lang={lang} />}
    </GetTheAppButton>;
};

require("./GetTheAppFooterWidget.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./GetTheAppFooterWidget.tsx");